import { api } from 'shared/api'

import { LiveChatStatisticsSchemas } from './schemas'

export const LiveChatStatisticsApi = {
  getTotalConversationsChartStats: api.account.createPost({
    url: '/liveChatStatistics/conversationsDynamics',
    schemas: LiveChatStatisticsSchemas.getTotalConversationsChartStats,
    scope: 'livechat',
    section: 'statistics',
  }),
  getConversationsByTeamMembersChartStats: api.account.createPost({
    url: '/liveChatStatistics/totalConversationsBreakdown',
    schemas: LiveChatStatisticsSchemas.getConversationsByTeamMembersChartStats,
    scope: 'livechat',
    section: 'statistics',
  }),
  getAverageResponseTime: api.account.createPost({
    url: '/liveChatStatistics/averageResponseTime',
    schemas: LiveChatStatisticsSchemas.getAverageResponseTime,
    scope: 'livechat',
    section: 'statistics',
  }),
  getAverageClosureTime: api.account.createPost({
    url: '/liveChatStatistics/averageClosureTime',
    schemas: LiveChatStatisticsSchemas.getAverageClosureTime,
    scope: 'livechat',
    section: 'statistics',
  }),
  getResponseRate: api.account.createPost({
    url: '/liveChatStatistics/responseRate',
    schemas: LiveChatStatisticsSchemas.getResponseRate,
    scope: 'livechat',
    section: 'statistics',
  }),
}
